import { formatDateTime } from '@thoughtspot/date-format-util';
import { useTranslation } from '@thoughtspot/i18n';
import { CellType, } from '@thoughtspot/radiant-react/widgets/table/table-list-view/cell/cell-type-service';
import { Vendor, } from "../../../services/generated/graphql-types";
export var TranslationsKeys;
(function (TranslationsKeys) {
    TranslationsKeys["TITLE"] = "spotiq.ml.integrations.title";
    TranslationsKeys["DESCRIPTION"] = "spotiq.ml.integrations.subtitle";
    TranslationsKeys["ERROR_INTEGRATION_LIST"] = "spotiq.ml.integrations.error";
    TranslationsKeys["EMPTY_INTEGRATION_LIST"] = "spotiq.ml.integrations.empty";
    TranslationsKeys["ADD_INTEGRATION_BTN"] = "spotiq.ml.integrations.add.Label";
    TranslationsKeys["NAME"] = "spotiq.ml.integrations.name.Label";
    TranslationsKeys["CREATED_ON"] = "spotiq.ml.integrations.createdOn.Label";
    TranslationsKeys["EDIT_ACTION"] = "spotiq.ml.integrations.edit.Label";
    TranslationsKeys["DELETE_ACTION"] = "spotiq.ml.integrations.delete.Label";
    TranslationsKeys["CANCEL"] = "spotiq.ml.integrations.cancel";
    TranslationsKeys["MODAL_TITLE_ADD_INTEGRATION"] = "spotiq.ml.integrations.add.modal.title";
    TranslationsKeys["MODAL_TITLE_EDIT_INTEGRATION"] = "spotiq.ml.integrations.edit.modal.title";
    TranslationsKeys["MODAL_TITLE_DELETE_INTEGRATION"] = "spotiq.ml.integrations.delete.modal.title";
    TranslationsKeys["MODAL_SUBTITLE_DELETE_INTEGRATION"] = "spotiq.ml.integrations.delete.modal.subtitle";
    TranslationsKeys["SELECT_VENDOR"] = "spotiq.ml.integrations.select.vendor.label";
    TranslationsKeys["SELECT_VENDOR_PLACEHOLDER"] = "spotiq.ml.integrations.select.vendor.placeholder";
    TranslationsKeys["ERROR_VENDORS_LIST"] = "spotiq.ml.integrations.select.vendor.error";
    TranslationsKeys["END_POINT_URL"] = "spotiq.ml.integrations.endpoint.url.label";
    TranslationsKeys["ENTER_URL"] = "spotiq.ml.integrations.endpoint.url.placeholder";
    TranslationsKeys["API_KEY"] = "spotiq.ml.integrations.apikey.label";
    TranslationsKeys["ENTER_API_KEY"] = "spotiq.ml.integrations.apikey.placeholder";
    TranslationsKeys["ADD_BTN"] = "spotiq.ml.integrations.add.modal.create";
    TranslationsKeys["UPDATE_INTEGRATION_BTN"] = "spotiq.ml.integrations.edit.modal.update";
    TranslationsKeys["SUCCESS_MSG_ADD_INTEGRATION"] = "spotiq.ml.integrations.add.modal.success";
    TranslationsKeys["SUCCESS_MSG_EDIT_INTEGRATION"] = "spotiq.ml.integrations.edit.modal.success";
    TranslationsKeys["SUCCESS_MSG_DELETE_INTEGRATION"] = "spotiq.ml.integrations.delete.modal.success";
    TranslationsKeys["FAILED_MSG_ADD_INTEGRATION"] = "spotiq.ml.integrations.add.modal.failed";
    TranslationsKeys["FAILED_MSG_EDIT_INTEGRATION"] = "spotiq.ml.integrations.edit.modal.failed";
    TranslationsKeys["FAILED_MSG_DELETE_INTEGRATION"] = "spotiq.ml.integrations.delete.modal.failed";
    TranslationsKeys["INVALID_URL"] = "spotiq.ml.integrations.endpoint.url.invalid";
    TranslationsKeys["NO_VENDORS_TO_ADD"] = "spotiq.ml.integrations.add.modal.vendors.empty";
})(TranslationsKeys || (TranslationsKeys = {}));
export function getColumnDefinitionsForMlIntegrations() {
    const { t } = useTranslation();
    const ML_INTEGRATION_LIST_COLUMN_DEFINITIONS = [
        {
            cellRendererFramework: CellType[CellType.text],
            headerName: t(TranslationsKeys.NAME),
            colId: 'name',
            flex: 3,
            sortable: false,
        },
        {
            cellRendererFramework: CellType[CellType.text],
            headerName: t(TranslationsKeys.CREATED_ON),
            colId: 'updatedAt',
            flex: 3,
            sortable: false,
        },
    ];
    return ML_INTEGRATION_LIST_COLUMN_DEFINITIONS;
}
export function transformToIntegrationData(row) {
    return {
        id: row?.id || '',
        vendor: row?.vendor.text || '',
        vendorName: row?.vendorName.text || '',
        endpointUrl: row?.endpointUrl.URL || '',
        apiKey: row?.apiKey.text || '',
        name: row?.name.text || '',
        createdAt: row?.createdAt.text || '',
        updatedAt: row?.updatedAt.text || '',
    };
}
export const transformToTableViewRows = (integrations) => {
    return integrations?.map(integration => {
        return {
            id: integration.integrationId !== ''
                ? integration.integrationId
                : integration.vendor,
            name: { text: integration.integrationName },
            vendor: { text: integration.vendor },
            vendorName: { text: integration.vendorName },
            endpointUrl: { URL: integration.endPointUrl },
            apiKey: { text: integration.apiKey },
            createdAt: {
                text: formatDateTime(integration.createdAt, 'dd MMM yyyy'),
            },
            updatedAt: {
                text: formatDateTime(integration.updatedAt, 'dd MMM yyyy'),
            },
        };
    });
};
export const transformToIntegrationInput = (row, integrationAction) => {
    const input = {
        action: integrationAction,
        integration: {
            integrationId: row?.id,
            vendor: row?.vendor,
            vendorName: row?.vendorName,
            endPointUrl: row?.endpointUrl,
            apiKey: row?.apiKey,
            integrationName: row?.name,
            createdAt: Number(row?.createdAt || 1234),
            updatedAt: Number(row?.updatedAt || 1234),
        },
    };
    return input;
};
export const VendorEnumToString = {
    [Vendor.Datarobot]: 'DataRobot',
    [Vendor.Thoughtspot]: 'ThoughtSpot',
};
export const checkURL = (url) => {
    const pattern = /^(https?:\/\/)/i;
    return pattern.test(url);
};
export const getStatusCodeAndMessageFromPrismError = (apolloError) => {
    const graphQLError = apolloError?.graphQLErrors[0];
    if (graphQLError &&
        graphQLError.extensions &&
        graphQLError.extensions.exception) {
        const upstreamResponse = graphQLError.extensions.exception?.upstreamResponse;
        const message = upstreamResponse?.data;
        const statusCode = upstreamResponse?.status;
        return { statusCode, message };
    }
    return null;
};
export const isSetIntegrationDisabeld = (data) => {
    return data === null || data?.apiKey === '' || data?.endpointUrl === '';
};
export const retryButton = (refetch) => ({
    label: 'Retry',
    onClick: () => refetch(),
});
//# sourceMappingURL=util.js.map